







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import axios from "axios";
import { swiper, swiperSlide } from "vue-awesome-swiper";

@Component({
  name: "SliderBlock",
  components: {
    swiper,
    swiperSlide,
  },
})
export default class SliderBlock extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  tabdata: any[] = [];
  public swiperOption: any = {
    spaceBetween: 30,
    centeredSlides: false,
    grabCursor: false,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: false,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  };
  created() {
    axios
      .get(`${API_URL}/pages/?&type=home.TabbedCollectionPage&fields=*`)
      .then((response) => {
        (this as any).tabdata = response.data;
      })
      .catch((e) => {
        (this as any).errors.push(e);
      });
  }
}
